import { createContext, useContext } from 'react';
import type { AuthContextValue } from './types';

/**
 * O contexto e o hook que as superfícies editoriais compartilhadas (anúncios,
 * consentimento) leem, separados do provider: o BlogAuthProvider
 * (./blog-auth-context) o alimenta com a sessão do portal (pool
 * `seesforce-portal-members`). Herdado da plataforma Shiba, onde o mesmo
 * contexto é provido pelo SDK do Cognito — é o que mantém estes componentes
 * iguais nos dois sites.
 */
export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error('useAuth must be used within an AuthProvider.');
  }
  return ctx;
}
